<template>
  <PanelEcoMode v-on:updateEtat="updateEtat" :current_data="this.donnees" :etat="this.etat" :panel="this.panel" v-if="this.panel"></PanelEcoMode>
  <PanelCo2 :etat="this.etat" :current_data="this.donnees"></PanelCo2>
  <EcoMode :etat="this.etat" @click="openPanel()" :panel="this.panel"></EcoMode>
</template>

<script>
import PanelEcoMode from './components/PanelEcoMode.vue'
import PanelCo2 from './components/PanelCo2.vue'
import EcoMode from './components/EcoMode.vue'

export default {
  name: 'App',
  components: {
    PanelEcoMode,
    PanelCo2,
    EcoMode
  },
  data () {
    return {
      donnees_wp: currentpost,
      etat: false, // Si eco-mode est activé ou non
      panel: false,
      donnees : {
        site : {
          kg : false
        },
        page : {
          gramme : false,
          watt : false,
        },
        utilisateur : {
          gramme : false,
          watt : false,
        },
        divers : {
          netflix : false,
          velo : {
            value : false,
            unit : false
          },
        }
      },
    }
  }, 
  methods : {
    checkEco() {
      let eco = this.getCookie('mode_eco');
      if(Boolean(eco) == true) {
        this.etat = true;
      } 
    },
    generateData(donnees) {
      this.donnees.site.compteur = [];
      this.donnees.site.kg = parseFloat(donnees.totalkg).toFixed(2);
      var compteur = this.donnees.site.kg.split('');
      this.donnees.site.compteur = compteur;
      this.donnees.page.gramme = parseFloat(donnees.grams_saved).toFixed(2);
      this.donnees.page.watt = parseFloat(donnees.watts_saved).toFixed(2);

      if(this.getCookie('grams_saved') && this.getCookie('watts_saved')) {
        this.donnees.utilisateur.gramme = parseFloat(this.getCookie('grams_saved')).toFixed(2);
        this.donnees.utilisateur.watt = parseFloat(this.getCookie('watts_saved')).toFixed(2);

        this.generateNetflix(this.donnees.utilisateur.gramme);
        this.generateVelo(this.donnees.utilisateur.gramme);
      }

      this.current_data = this.donnees.site.kg;
    },
    generateNetflix(gramme) {
      var netflix_epi = gramme / 55;
      netflix_epi = netflix_epi.toFixed(2);
      if (netflix_epi % 1 === 0) {
        netflix_epi = Math.floor(netflix_epi);
      }
      this.donnees.divers.netflix = netflix_epi;
    },
    generateVelo(gramme) {
      const distance_velo = gramme * 100;
      if (parseInt(distance_velo).toString().length >= 4) {
        var distance_km = distance_velo / 1000;
        var formatted_distance_km = distance_km.toFixed(2);
        this.donnees.divers.velo.value = formatted_distance_km;
        this.donnees.divers.velo.unit = "km";
      } else {
        var distance = parseInt(distance_velo);
        this.donnees.divers.velo.value = distance;
        this.donnees.divers.velo.unit = "m";
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    updateEtat(data) {
        this.etat = data;
    },
    openPanel() {
      if(this.panel == true) { this.panel = false; } else { this.panel = true; }
    }
  },
  mounted() {
    this.checkEco();
    this.generateData(this.donnees_wp); 
    
  },
}
</script>

<style>
:root {
  --font: 'Poppins';
}
#app {
  font-family: var(--font), Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  max-width:320px;
  margin:auto;
  font-size:14px;
  z-index: 1000000;
  position:fixed;
  right: 50px;
  bottom: 100px;
}
@media screen and (max-width:500px) {
  #app {
    bottom:170px;
    right:10px;
  }
}
</style>
